import Step6 from './Step6'

export default Step6
